import template   from './my-updates.html'
import './my-updates.styl'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-updates.component.js